<form [formGroup]="form" (submit)="$event.preventDefault()">
  <mat-card style="box-shadow: none;">
    <mat-card-content class="container-fluid">
      <div class="row">
        <mat-card-title class="section-title">
          Report Approval
        </mat-card-title>
        <br>
        <div class="col-sm-12">
          <div class="row" *ngIf="isFieldVisible('areaLeadInspEng')">
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                 <label class="form-label">
                  {{displayNames['areaLeadInspEng']}}
                  <span *ngIf="isRequired('areaLeadInspEng')" class="required"></span>
                  <mat-spinner *ngIf="loadingFields()['areaLeadInspEng']" diameter="11"></mat-spinner>
                </label>
                <mat-form-field class="full-width"
                  [ngClass]="_fieldHighlightService.getHighlightClasses('areaLeadInspEng', FieldLocation.ApprovalFlowTab)">
                  <input matInput formControlName="areaLeadInspEng"
                    [placeholder]="'Enter ' + displayNames['areaLeadInspEng']" />
                  <mat-error *ngIf="getErrorMessage('areaLeadInspEng') as errorMessage">{{ errorMessage }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <mat-form-field class="full-width">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                    formControlName="areaLeadInspEngDescription" readonly></textarea>
                  <mat-error *ngIf="getErrorMessage('areaLeadInspEngDescription') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="isFieldVisible('inspEngSupervisor')">
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <label class="form-label">
                  {{displayNames['inspEngSupervisor']}}
                  <span *ngIf="isRequired('inspEngSupervisor')" class="required"></span>
                  <mat-spinner *ngIf="loadingFields()['inspEngSupervisor']" diameter="11"></mat-spinner>
                </label>
                <mat-form-field class="full-width"
                  [ngClass]="_fieldHighlightService.getHighlightClasses('inspEngSupervisor', FieldLocation.ApprovalFlowTab)">
                  <input matInput formControlName="inspEngSupervisor"
                    [placeholder]="'Enter ' + displayNames['inspEngSupervisor']">

                  <mat-error *ngIf="getErrorMessage('inspEngSupervisor') as errorMessage">{{ errorMessage }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <mat-form-field class="full-width">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                    formControlName="inspEngSupervisorDescription" readonly></textarea>
                  <mat-error *ngIf="getErrorMessage('inspEngSupervisorDescription') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="isFieldVisible('srOpsConsultant')">
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                  <label class="form-label">
                  {{displayNames['srOpsConsultant']}}
                  <span *ngIf="isRequired('srOpsConsultant')" class="required"></span>
                  <mat-spinner *ngIf="loadingFields()['srOpsConsultant']" diameter="11"></mat-spinner>
                </label>
                <mat-form-field class="full-width"
                  [ngClass]="_fieldHighlightService.getHighlightClasses('srOpsConsultant', FieldLocation.ApprovalFlowTab)">
                  <input matInput formControlName="srOpsConsultant"
                    [placeholder]="'Enter ' + displayNames['srOpsConsultant']">
                  <mat-error *ngIf="getErrorMessage('srOpsConsultant') as errorMessage">{{ errorMessage }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <mat-form-field class="full-width">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                    formControlName="srOpsConsultantDescription" readonly></textarea>
                  <mat-error *ngIf="getErrorMessage('srOpsConsultantDescription') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  @if (reportApprovalVisibility()) {
  <mat-card style="box-shadow: none;">
    <mat-card-content class="container-fluid">
      <div class="row">
        <mat-card-title class="section-title">
          Plan Approval
        </mat-card-title>
        <br>
        <div class="col-sm-12">

          <div class="row" *ngIf="isFieldVisible('localTechnicalAuthority')">
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <label class="form-label">
                  {{displayNames['localTechnicalAuthority']}}
                  <span *ngIf="isRequired('localTechnicalAuthority')" class="required"></span>
                  <mat-spinner *ngIf="loadingFields()['localTechnicalAuthority']" diameter="11"></mat-spinner>
                </label>
                <mat-form-field class="full-width"
                  [ngClass]="_fieldHighlightService.getHighlightClasses('localTechnicalAuthority', FieldLocation.ApprovalFlowTab)">
                  <input matInput formControlName="localTechnicalAuthority"
                    [placeholder]="'Enter ' + displayNames['localTechnicalAuthority']">
                  <mat-error *ngIf="getErrorMessage('localTechnicalAuthority') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <mat-form-field class="full-width">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                    formControlName="localTechnicalAuthorityDescription" readonly></textarea>
                  <mat-error *ngIf="getErrorMessage('localTechnicalAuthorityDescription') as errorMessage">{{
                    errorMessage }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="isFieldVisible('assetTypeHCEPO')">
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <label class="form-label">
                  {{displayNames['assetTypeHCEPO']}}
                  <span *ngIf="isRequired('assetTypeHCEPO')" class="required"></span>
                  <mat-spinner *ngIf="loadingFields()['assetTypeHCEPO']" diameter="11"></mat-spinner>
                </label>
                <mat-form-field class="full-width"
                  [ngClass]="_fieldHighlightService.getHighlightClasses('assetTypeHCEPO', FieldLocation.ApprovalFlowTab)">
                  <input matInput formControlName="assetTypeHCEPO"
                    [placeholder]="'Enter ' + displayNames['assetTypeHCEPO']">
                  <mat-error *ngIf="getErrorMessage('assetTypeHCEPO') as errorMessage">{{ errorMessage }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <mat-form-field class="full-width">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                    formControlName="assetTypeHCEPODescription" readonly></textarea>
                  <mat-error *ngIf="getErrorMessage('assetTypeHCEPODescription') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div [formGroup]="endorsersForm2">
            <div formArrayName="endorsers">

              <div class="row" *ngFor="let endorser of endorsers.controls; let i = index">
                <div class="col-sm-12">
                  <div class="horizontal-form-field">
                    <label class="form-label"> Endorser - {{ i + 1 }} </label>

                    <mat-form-field
                      class="full-width"
                      [ngClass]="_fieldHighlightService.getHighlightClasses('additionalEndorser' + (i + 1), FieldLocation.ApprovalFlowTab)"
                    >
                      <input
                        matInput
                        [formControlName]="i"
                        [placeholder]="'Enter Endorser -' + (i + 1)"
                      />

                      <mat-error *ngIf="endorsers.at(i).hasError">
                        {{ endorsers.at(i).value ? 'Invalid email' : 'Email is required' }}
                      </mat-error>

                      <mat-error *ngIf="endorsers.at(i).errors?.['duplicate']">
                        Two or more endorsers are the same.
                      </mat-error>

                    </mat-form-field>

                    @if (!form.get('additionalEndorser' + (i + 1))?.value) {
                      <button mat-icon-button (click)="deleteEndorser(i)">
                        <mat-icon svgIcon="trash-can" />
                      </button>
                    }                      
                  </div>
                </div>
              </div>

            </div>
          </div>

          @if ( buttonScript.addNewEndorsers() ) {
            <div class="row mb-4">
              <div class="col-sm-12">
                <button mat-stroked-button [disabled]="isProcessing()" (click)="addNewEndorser()" [disabled]="endorsers.length >= ENDORSERS_MAX_LENGTH">
                  <mat-icon svgIcon="plus" />
                  Add additional endorsers if necessary
                </button>
              </div>
            </div>
          }

          <div class="row" *ngIf="isFieldVisible('areaOpsSuperintendent')">
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <label class="form-label">
                  {{displayNames['areaOpsSuperintendent']}}
                  <span *ngIf="isRequired('areaOpsSuperintendent')" class="required"></span>
                  <mat-spinner *ngIf="loadingFields()['areaOpsSuperintendent']" diameter="11"></mat-spinner>
                </label>
                <mat-form-field class="full-width"
                  [ngClass]="_fieldHighlightService.getHighlightClasses('areaOpsSuperintendent', FieldLocation.ApprovalFlowTab)">
                  <input matInput formControlName="areaOpsSuperintendent"
                    [placeholder]="'Enter ' + displayNames['areaOpsSuperintendent']">
                  <mat-error *ngIf="getErrorMessage('areaOpsSuperintendent') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <mat-form-field class="full-width">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                    formControlName="areaOpsSuperintendentDescription" readonly></textarea>
                  <mat-error *ngIf="getErrorMessage('areaOpsSuperintendentDescription') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="isFieldVisible('productionOperationManager')">
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <label class="form-label">
                  {{displayNames['productionOperationManager']}}
                  <span *ngIf="isRequired('productionOperationManager')" class="required"></span>
                  <mat-spinner *ngIf="loadingFields()['productionOperationManager']" diameter="11"></mat-spinner>
                </label>
                <mat-form-field class="full-width"
                  [ngClass]="_fieldHighlightService.getHighlightClasses('productionOperationManager', FieldLocation.ApprovalFlowTab)">
                  <input matInput formControlName="productionOperationManager"
                    [placeholder]="'Enter ' + displayNames['productionOperationManager']">
                  <mat-error *ngIf="getErrorMessage('productionOperationManager') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <mat-form-field class="full-width">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                    formControlName="productionOperationManagerDescription" readonly></textarea>
                  <mat-error *ngIf="getErrorMessage('productionOperationManagerDescription') as errorMessage">{{
                    errorMessage }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="isFieldVisible('generalManagerOperation')">
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <label class="form-label">
                  {{displayNames['generalManagerOperation']}}
                  <span *ngIf="isRequired('generalManagerOperation')" class="required"></span>
                  <mat-spinner *ngIf="loadingFields()['generalManagerOperation']" diameter="11"></mat-spinner>
                </label>
                <mat-form-field class="full-width"
                  [ngClass]="_fieldHighlightService.getHighlightClasses('generalManagerOperation', FieldLocation.ApprovalFlowTab)">
                  <input matInput formControlName="generalManagerOperation"
                    [placeholder]="'Enter ' + displayNames['generalManagerOperation']">
                  <mat-error *ngIf="getErrorMessage('generalManagerOperation') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <mat-form-field class="full-width">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                    formControlName="generalManagerOperationDescription" readonly></textarea>
                  <mat-error *ngIf="getErrorMessage('generalManagerOperationDescription') as errorMessage">{{
                    errorMessage }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="isFieldVisible('generalDirectorOperation')">
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <label class="form-label">
                  {{displayNames['generalDirectorOperation']}}
                  <span *ngIf="isRequired('generalDirectorOperation')" class="required"></span>
                  <mat-spinner *ngIf="loadingFields()['generalDirectorOperation']" diameter="11"></mat-spinner>
                </label>
                <mat-form-field class="full-width"
                  [ngClass]="_fieldHighlightService.getHighlightClasses('generalDirectorOperation', FieldLocation.ApprovalFlowTab)">
                  <input matInput formControlName="generalDirectorOperation"
                    [placeholder]="'Enter ' + displayNames['generalDirectorOperation']">
                  <mat-error *ngIf="getErrorMessage('generalDirectorOperation') as errorMessage">{{ errorMessage }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="horizontal-form-field">
                <mat-form-field class="full-width">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                    formControlName="generalDirectorOperationDescription" readonly></textarea>
                  <mat-error *ngIf="getErrorMessage('generalDirectorOperationDescription') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  }

  <mat-card style="box-shadow: none;" *ngIf="isFieldVisible('informedEmailsTo') || isFieldVisible('informedEmailsCc')">
    <mat-card-content class="container-fluid">
      <mat-card-title>

      </mat-card-title>
      <div class="row" *ngIf="canShowDistributionListDropdown()">
        <div class="col-sm-12">
          <div class="horizontal-form-field">
            <label class="form-label">Distribution List</label>
            <mat-form-field class="full-width">
              <mat-select placeholder="Select distribution list" [disabled]="!canEditDistributionList()" (selectionChange)="onDistributionListTitleSelected($event.value)">
                <mat-option *ngFor="let item of distributionListOptions()" [value]="item">{{ item.title }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12" *ngIf="isFieldVisible('informedEmailsTo')">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames['informedEmailsTo']}}</label>
            <mat-form-field class="full-width">
              <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="6"
                formControlName="informedEmailsTo"
                [placeholder]="'Enter ' + displayNames['informedEmailsTo']"></textarea>
              <mat-error *ngIf="getErrorMessage('informedEmailsTo') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-12" *ngIf="isFieldVisible('informedEmailsCc')">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames['informedEmailsCc']}}</label>
            <mat-form-field class="full-width">
              <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="6"
                formControlName="informedEmailsCc"
                [placeholder]="'Enter ' + displayNames['informedEmailsCc']"></textarea>
              <mat-error *ngIf="getErrorMessage('informedEmailsCc') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card style="box-shadow: none;">
    <mat-card-content class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <mat-card-title class="section-title">
            FDM Events
          </mat-card-title>
          <br>
          <div class="history-table-container">
            <div class="history-table-scroll-wrapper">
              <table mat-table matSort [dataSource]="historyDataSource" class="subgrid-table">
                <ng-container matColumnDef="currentState">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort">
                    State
                    <app-table-column-filter class="column-filter" [class.active]="isActive('currentState')" (filterChange)="applyFilter($event, 'currentState')" />
                  </th>
                  <td mat-cell *matCellDef="let item">{{ item.currentState }}</td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort">
                    Type
                    <app-table-column-filter class="column-filter" [class.active]="isActive('type')" (filterChange)="applyFilter($event, 'type')" />
                  </th>
                  <td mat-cell *matCellDef="let item">{{ [item.type] }}</td>
                </ng-container>
                <ng-container matColumnDef="comment">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort">
                    Comment
                    <app-table-column-filter class="column-filter" [class.active]="isActive('comment')" (filterChange)="applyFilter($event, 'comment')" />
                  </th>
                  <td mat-cell *matCellDef="let item">{{ [item.comment] }}</td>
                </ng-container>
                <ng-container matColumnDef="actionItemStatus">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort">
                    Action Item Status
                    <app-table-column-filter class="column-filter" [class.active]="isActive('actionItemStatus')" (filterChange)="applyFilter($event, 'actionItemStatus')" />
                  </th>
                  <td mat-cell *matCellDef="let item">{{ [item.actionItemStatus] }}</td>
                </ng-container>

                <ng-container matColumnDef="created">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort">
                    Created On
                    <app-table-column-filter class="column-filter" [class.active]="isActive('created')" (filterChange)="applyFilter($event, 'created')" />
                  </th>
                  <td mat-cell *matCellDef="let item">{{ item.created | date: 'dd MMMM yyyy HH:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="createdBy">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort">
                    Created By
                    <app-table-column-filter class="column-filter" [class.active]="isActive('createdBy')" (filterChange)="applyFilter($event, 'createdBy')" />
                  </th>
                  <td mat-cell *matCellDef="let item">{{ item.createdBy }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="historyDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: historyDisplayedColumns;"></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>

<div class="processing-overlay" *ngIf="isProcessing()">
  <div class="processing-text">
    <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
    <div>Processing…</div>
  </div>
</div>
